import { ILineChartSettings } from '@/pages/Dashboards/Charts/LineChart/lineChart.types.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import lineChartUtils from '@/pages/Dashboards/Charts/LineChart/lineChart.utils.ts'
import LineChartSettingsContent from '@/pages/Dashboards/Charts/LineChart/LineChartSettingsSidePage/LineChartSettingsContent'
import { memo, useEffect } from 'react'

interface IProps {
  onChange: (val: ILineChartSettings) => void
}

const CreateLineChartSettingsContent = (props: IProps) => {
  const [settings, setSettings, handleChange] = useStateWithChange(lineChartUtils.generateEmptyChartSettings())

  useEffect(() => {
    props.onChange(settings)
  }, [settings, props.onChange])

  const {
    handleElementDelete: handleLineDelete,
    handleElementUpdate: handleLineUpdate,
    handleCreateNewElement: handleLineCreate,
  } = useNestedArrayChangeCallbacks({
    nestedArrayKey: 'lines',
    sourceObjectSetter: setSettings,
    newEntityGenerator: lineChartUtils.generateEmptyLine,
  })

  return (
    <div className="flex-lines gap16">
      <h4 className="text-heading-4">Создание виджета: Линейный график</h4>
      <LineChartSettingsContent
        settings={settings}
        onChange={handleChange}
        handleLineDelete={handleLineDelete}
        handleLineUpdate={handleLineUpdate}
        handleLineCreate={handleLineCreate}
      />
    </div>
  )
}

export default memo(CreateLineChartSettingsContent)
